import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class Percent extends PureComponent {
    static propTypes = {
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }

    static defaultProps = {
        value: null,
    }

    render() {
        const { value } = this.props

        return value && <div>{`${value} %`}</div>
    }
}
